module.exports = __webpack_public_path__ + "img/translationeditor_25.555432ed.jpg";